export const PLUGIN_TYPE = {
    CONSOLE: 'console',
    TRACE: 'trace',
} as const

export type PluginType = Constant<typeof PLUGIN_TYPE>
